import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[noAutocomplete]'
})
export class NoAutocompleteDirective implements OnInit {
  
  constructor(private el: ElementRef) {}

  ngOnInit() {
    const input = this.el.nativeElement;
    
    // Multiples protections
    input.setAttribute('autocomplete', 'new-password');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('name', 'field_' + Math.random().toString(36).substring(7));
    
    // Retirer readonly au focus
    input.addEventListener('focus', () => {
      input.removeAttribute('readonly');
    });
    
    // Remettre readonly au blur (optionnel)
    input.addEventListener('blur', () => {
      setTimeout(() => {
        input.setAttribute('readonly', 'readonly');
      }, 100);
    });
  }
}